import { styled } from '@linaria/react';
export var Fonts = /*#__PURE__*/styled("div")({
  name: "Fonts",
  class: "f1d8n3tr"
});

require("../../../apps/tv/.linaria-cache/packages/@webtv/fonts/index.linaria.module.css");